import echarts from 'echarts'
import filters from '@/filters'
var option = {
  grid: {
    top: '15',
    left: '20',
    right: '20',
    bottom: '50',
  },
  legend: {
    icon: 'rect',
    left: 'center',
    align: 'auto',
    bottom: '0',
    itemWidth: 12,
    itemHeight: 3,
    textStyle: {
      color: 'rgba(255,255,255,0.85)'
    },
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: 'rgba(37, 50, 85, 0)',
    formatter: function (params) {
      let str = `<div style="background: #3C4252;border-radius: 8px;width: 271px;height: 66px;">
            <div style="width: 100%;
                height: 25px;
                line-height: 25px;
                font-size: 10px;
                color: #C8CEDE;
                border-bottom: 1px solid rgba(255,255,255, 0.1);
                padding-left: 20px;">
                ${params[0].name}
            </div>
            <div style="display:flex;align-items: center;height: 40px;">
            <span style="font-size: 12px;color: #D0D6E6;font-weight: bold;margin-left: 20px;">${params[0].seriesName}:</span>
            <span style="font-size: 14px;color: #FFCA5C;font-weight: bold;margin-left: 8px;">${filters.changeNum(params[0].data)}</span>
            <span style="font-size: 12px;color: #D0D6E6;font-weight: bold;margin-left: 24px;">${params[1].seriesName}:</span>
            <span style="font-size: 14px;color: #FFCA5C;font-weight: bold;margin-left: 8px;">${filters.numRate(params[1].data)}</span>
            </div>
        </div>`;
      return str;
    }
  },

  xAxis: [{
    show: true,
    type: 'category',
    axisLine: {
      show: true,
      lineStyle: {
        color: 'rgba(255,255,255,0.1)',
      }
    },
    splitArea: {
      // show: true,
      color: '#8890A6',
      lineStyle: {
        color: '#8890A6'
      },
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: '#8890A6',
        fontSize: 10
      },
    },
    splitLine: {
      show: false
    },
    boundaryGap: false,
    data: [],

  }],
  yAxis: [{
    type: 'value',
    min: 0,
    // max: 140,
    splitNumber: 4,
    splitLine: {
      show: true,
      lineStyle: {
        color: 'rgba(255,255,255,0.1)'
      }
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      show: false,
      textStyle: {
        color: '#8890A6',
        fontSize: 10
      },
    },
    axisTick: {
      show: false,
    },
  }, {
    type: 'value',
    min: 0,
    // max: 140,
    splitNumber: 4,
    splitLine: {
      show: true,
      lineStyle: {
        color: 'rgba(255,255,255,0.1)'
      }
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      show: false,
      textStyle: {
        color: '#8890A6',
        fontSize: 10
      },
    },
    axisTick: {
      show: false,
    },
  }],
  series: [{
    name: '',
    type: 'line',
    smooth: true,
    yAxisIndex: 0,
    symbol: 'circle',
    symbolSize: 0,
    data: [],
    areaStyle: {
      normal: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: 'rgba(255, 202, 92, 0.5)'
        }, {
          offset: 0.8,
          color: 'rgba(255, 202, 92, 0)'
        }], false),
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowBlur: 10
      },
    },
    itemStyle: {
      normal: {
        color: '#FFCA5C'
      }
    },
  }, {
    name: '行业占比',
    type: 'line',
    smooth: true,
    yAxisIndex: 1,
    symbol: 'circle',
    symbolSize: 0,
    data: [],
    areaStyle: {
      normal: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: 'rgba(129,92,255, 0.5)'
        }, {
          offset: 0.8,
          color: 'rgba(129,92,255, 0)'
        }], false),
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowBlur: 10
      },
    },
    itemStyle: {
      normal: {
        color: '#815CFF'
      }
    },

  }]
}

export default option